<template>
    <div id="quizContainer" class="show">
        <div class="title">
            <span class="typography--s4 text-uppercase text-center">
                {{$t('1087')}}
                <!-- Quiz -->
            </span>
            <button @click="closeQuizPop()" id="btnQuizToggle"></button>
            <div class="clearfix"></div>
        </div>
        <div class="container">
            <div class="guide">
                <img class="d-landscape-none" src="../../assets/woman-full.svg" alt="Woman"/>
                <img class="d-portrait-none" src="../../assets/woman-full-white.svg" alt="Woman"/>
                <div>
                    <!-- <span class="d-portrait-none">Wait,</span> -->
                    <span>{{$t('1088')}}</span>
                </div>
            </div>
            <div class="question typography--s4 text-center" v-if="currentTimelineContents">
                {{currentTimelineContents.quiz.question}}
                
            </div>
            <div class="submit">
                <button @click="openQuizDetail()" class="btn-submit">
                    {{$t('1089')}}
                    <!-- View Detail -->
                </button>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 퀴즈 컨텐츠 컴포넌트(my learning lesson study - timeline quiz contents component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['currentTimelineContents'],
    
    methods: {
        // 팝업 닫기(close quiz pop)
        closeQuizPop() {
            this.$emit('closeQuizPop')
        },

        // 퀴즈 상세 열기(open quiz detail)
        openQuizDetail() {
            this.$emit('openQuizDetail')
        }
    }
}
</script>